module.exports = __webpack_public_path__ + "a1935f207416c7ed14d9b54e1af40c7e.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icon-instagram.svg
// module id = 0U4Q
// module chunks = 5